import 'regenerator-runtime/runtime';
import 'whatwg-fetch';
import 'core-js/stable/object/assign';
import '@webcomponents/webcomponentsjs';
import './closest';

// IE pollyfill for toggleAttribute
if (!Element.prototype.toggleAttribute) {
  Element.prototype.toggleAttribute = function (name, force) {
    if (force !== void 0) force = !!force;

    if (this.hasAttribute(name)) {
      if (force) return true;

      this.removeAttribute(name);
      return false;
    }
    if (force === false) return false;

    this.setAttribute(name, '');
    return true;
  };
}

// if (/MSIE \d|Trident.*rv:/.test(navigator.userAgent)) {
//   require('react-app-polyfill/ie11');
//   require('react-app-polyfill/stable');
//   require('@webcomponents/webcomponentsjs');
//   require('./closest');
// }
